import React from 'react';
import { IWelcomePackageStrapi } from '../types';
import Link from 'Components/shared/Link/Link';
import { PATHS } from 'Libraries/routes.library';
import { useRouter } from 'next/router';
import { ButtonTextOnly } from '@spinwise/react-component-library/ButtonTextOnly';
import { useTranslation } from 'react-i18next';
import { EBrandButtonTypes } from 'Libraries/buttons.library';
import {
  EBaseButtonSize,
  EButtonBorderRadiusStrength,
  EButtonTextAlign,
} from '@spinwise/react-component-library/ButtonAbstract';
import { EBaseTextSize, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import BottomCard from '../BottomCard/BottomCard';
import { useSelector } from 'react-redux';
import { IApplicationState } from '@spinwise/spinwise-core';
import styles from './BottomCards.module.scss';

interface IBottomCardsProps {
  regtype?: any;
  dynamic_welcome_package?: Array<IWelcomePackageStrapi>;
}

const BottomCards = ({ regtype, dynamic_welcome_package }: IBottomCardsProps) => {
  const router = useRouter();
  const { t } = useTranslation();

  const geo = useSelector((state: IApplicationState) => state.globalReducer?.geo);

  const getPromoText = (value: String) => {
    if (['SWE', 'NOR'].includes(geo?.code)) {
      return t(`swe.${regtype}.${value}`);
    }
    return t(`${regtype}.${value}`);
  };

  const bottomCardC = dynamic_welcome_package?.map(el => {
    return {
      title: el.title ?? '',
      subtitle: el.subtitle ?? '',
      description: el.description ?? '',
      number: el.rank ?? 0,
      image: el.image?.data?.attributes?.url ?? '',
      buttonComponent:
        el.rank == 1 ? (
          <Link
            key={el.title + el.subtitle}
            href={{
              pathname: PATHS.REGISTER,
              query: {
                ...router.query,
              },
            }}
            className="w-100"
            data-qa="button-promo-block-register"
          >
            <ButtonTextOnly
              label={t('homepage.c2.create.account.btn')}
              type={EBrandButtonTypes.Tertiary}
              size={EBaseButtonSize.Medium}
              textSize={EBaseTextSize.Large}
              fullWidth={true}
              textWeight={EBaseTextWeight.W500}
              alignText={EButtonTextAlign.Center}
              borderRadius={EButtonBorderRadiusStrength.Seven}
            />
          </Link>
        ) : (
          <div className={`${styles.unlock_button} d-fl ai-c jc-c`} key={el.title + el.subtitle}>
            <p>{t('homepage.c2.button.deposit.to.unlock.' + el?.rank)}</p>
          </div>
        ),
    };
  });

  if (bottomCardC?.length === 0) {
    return null;
  }

  return (
    <div className={styles.bottom_container}>
      <p className={styles.cards_block_title}>
        {/* Your 100% Bonus + 250 Free Spins Welcome package! */}
        {getPromoText('homepage.c2.welcome.package.bottom.title')}
      </p>
      <div
        className={`${styles.bottom_container_cards} ${
          bottomCardC.length == 3
            ? styles.bottom_container_cards_3
            : bottomCardC.length == 2
            ? styles.bottom_container_cards_2
            : ''
        }`}
      >
        {bottomCardC.map(el => {
          return (
            <BottomCard
              key={el.title + el.subtitle}
              title={el.title}
              subtitle={el.subtitle}
              number={el.number}
              description={el.description}
              buttonComponent={el.buttonComponent}
              image={el.image}
            ></BottomCard>
          );
        })}
      </div>
    </div>
  );
};

export default BottomCards;
